<template>
	<div id="registerNOPOperation" class="flex justify-center">
		<div class="self-center max-w max-w-md" style="min-width:50%">
			<form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
				<div class="mb-4 ">
					<v-select
						placeholder="Find your nop operation."
						:options="nopOperationsList"
						:onChange="onNOPOperationChange"
						:on-search="searchNOPOperations"
						:filterable="false"
					>
					</v-select>
				</div>

				<div class="flex justify-center" v-if="nopUserDetails.NOPID">
					<table class="certifierDetailsTable">
						<tr>
							<th>
								Email
							</th>
							<td>
								{{ nopUserDetails.Email }}
							</td>
						</tr>

						<tr>
							<th>
								NOP ID
							</th>
							<td>{{ nopUserDetails.NOPID }}</td>
						</tr>

						<tr>
							<th>
								Name
							</th>
							<td>{{ nopUserDetails.OpName }}</td>
						</tr>

						<tr>
							<th>
								Country/City
							</th>
							<td>
								{{ nopUserDetails.City + " " + nopUserDetails.Country }}
							</td>
						</tr>
					</table>
				</div>

				<div class="flex justify-center pt-5">
					<button @click="submitNOPUserToDB" class="" type="button">
						Register account
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";

export default {
	name: "LoginView",
	created() {},
	data() {
		return {
			password: "",
			username: "",
			nopOperationsList: [],
			nopUserDetails: {}
		};
	},
	methods: {
		submitNOPUserToDB() {
			var URL = this.$store.state.urls.POST_ADD_NEW_NOP_USER;

			asyncRequest.ServerAPI({
				progressBarObj: this.$Progress,
				method: "POST",
				api: URL,
				postData: { UserEmail: this.nopUserDetails.Email },
				onSuccessCallback: function() {},
				flags: asyncRequest.M_FAIL | asyncRequest.M_SUCCESS,
				beforeAfterCallback: false
			});
		},
		onNOPOperationChange(changedVal) {
			if (!changedVal || !changedVal.value) {
				this.nopUserDetails = {};
				return;
			}
			this.nopUserDetails = changedVal.value;
		},
		searchNOPOperations(searchQry, isLoading) {
			var URL = this.$store.state.urls.GET_NOP_USER_BY_NAME + searchQry + "/";
			//this is a deep copy to makesure no one messes with my original search query
			var tmp = ("" + searchQry).replace(/ /g, "");
			//figure which method to call, if number its nop, if not, then searching by name
			if (Number.isInteger(Number(tmp))) {
				URL = this.$store.state.urls.GET_NOP_USER_BY_NOP_ID + tmp + "/";
			}
			isLoading(true);
			asyncRequest.ServerAPI({
				progressBarObj: this.$Progress,
				method: "GET",
				api: URL,
				onSuccessCallback: dataIn => {
					this.reorganizeNOPUsersLookupData(dataIn);
					isLoading(false);
				},
				flags: asyncRequest.M_FAIL,
				beforeAfterCallback: false
			});
		},
		//Once we find the producers reorg the data to something vue-select can understand
		reorganizeNOPUsersLookupData(dataIn) {
			if (!Array.isArray(dataIn.Data)) {
				this.nopOperationsList = [];
				return;
			}

			this.nopOperationsList = [];
			var d = dataIn.Data;
			for (var i = 0; i < d.length; i++) {
				var l = d[i].NOPID + " : " + d[i].OpName;

				if (d[i].City || d[i].Country) {
					l += " (" + d[i].City + " - " + d[i].Country + ")";
				}

				if (d[i].Email == "") {
					l = "(--)" + l;
				}

				this.nopOperationsList.push({
					value: d[i],
					label: l
				});
			}
		}
	},
	components: {}
};
</script>

<style scoped>
/* We need to do some css to makesure this page is drawn over everything and takes the whole screen space */
#registerNOPOperation {
	height: 100%;
	width: 100%;
	background-color: #000;
	position: fixed;
	top: 0;
	z-index: 999;
}

td,
th {
	font-size: 14px;
	padding-bottom: 10px;
	font-weight: 400;
}
</style>
